import { create } from "zustand";
import { PLAY_STYLES, type PlayStyle } from "../core/theory/styles";
import { songId } from "./keyStore";
import { useProjectStore } from "./projectStore";

// Play style picked for the loaded song (원래대로 · 개방현 울림 · 베이스 잇기 · 쉽게 · 고음 3줄).
// Remembered per song on this device, like the key/capo; not part of the shared link.

const STORE_PREFIX = "tutti.style.";

function load(id: string): PlayStyle {
  try {
    const raw = localStorage.getItem(STORE_PREFIX + id);
    return PLAY_STYLES.includes(raw as PlayStyle) ? (raw as PlayStyle) : "orig";
  } catch {
    return "orig";
  }
}

interface StyleState {
  style: PlayStyle;
  set: (style: PlayStyle) => void;
}

export const useStyleStore = create<StyleState>((set) => ({
  style: "orig",
  set: (style) => {
    set({ style });
    const id = songId(useProjectStore.getState().source);
    if (!id) return;
    try {
      if (style === "orig") localStorage.removeItem(STORE_PREFIX + id);
      else localStorage.setItem(STORE_PREFIX + id, style);
    } catch { /* storage blocked: the style just isn't remembered */ }
  },
}));

/** restore the style whenever a song is loaded. Returns the unsubscribe. */
export function bindStyleToSong(): () => void {
  const apply = () => {
    const id = songId(useProjectStore.getState().source);
    useStyleStore.setState({ style: id ? load(id) : "orig" });
  };
  apply();
  return useProjectStore.subscribe((s, prev) => { if (s.source !== prev.source) apply(); });
}
